import React, { useRef, useState } from "react";
import "./ProductMediaCarousel.css";
import Container from "../Container";

const MEDIA_ITEMS = [
  { id: "media1", src: "/assets/media1.mp4", title: "¿Qué es la ortoqueratología?" },
  { id: "media2", src: "/assets/media3.mp4", title: "¿Qué son los lentes de contacto esclerales?" },
  { id: "media3", src: "/assets/media2.mp4", title: "¿Querés usar lentes de contacto?" },
];

const ProductMediaCarousel = () => {
  const trackRef = useRef(null);
  const videoRefs = useRef({});
  const [activeIndex, setActiveIndex] = useState(0);

  const stopVideos = () => {
    Object.values(videoRefs.current).forEach((video) => {
      if (!video) return;
      video.pause();
      video.currentTime = 0;
    });
  };

  const getCurrentIndex = () => {
    const track = trackRef.current;
    if (!track) return 0;

    const cards = Array.from(track.querySelectorAll(".product-media-card"));
    const trackCenter = track.scrollLeft + track.clientWidth / 2;
    return cards.reduce((closestIndex, card, index) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const closestCenter = cards[closestIndex].offsetLeft + cards[closestIndex].offsetWidth / 2;
      return Math.abs(cardCenter - trackCenter) < Math.abs(closestCenter - trackCenter)
        ? index
        : closestIndex;
    }, 0);
  };

  const scrollToIndex = (index) => {
    const track = trackRef.current;
    if (!track) return;

    const cards = track.querySelectorAll(".product-media-card");
    stopVideos();
    setActiveIndex(index);
    track.scrollTo({ behavior: "smooth", left: cards[index].offsetLeft });
  };

  const moveCarousel = (direction) => {
    const currentIndex = getCurrentIndex();
    const nextIndex = (currentIndex + direction + MEDIA_ITEMS.length) % MEDIA_ITEMS.length;
    scrollToIndex(nextIndex);
  };

  const handleTrackScroll = () => {
    stopVideos();
    setActiveIndex(getCurrentIndex());
  };

  return (
    <Container>
      <section className="product-media section-spacing" aria-labelledby="product-media-title">
        <h2 id="product-media-title">Conoce más de nuestros productos</h2>

        <div className="product-media-carousel">
          <button
            aria-label="Contenido anterior"
            className="product-media-navigation"
            onClick={() => moveCarousel(-1)}
            type="button"
          >
            ←
          </button>

          <div className="product-media-track" onScroll={handleTrackScroll} ref={trackRef}>
            {MEDIA_ITEMS.map((item) => (
              <article className="product-media-card" key={item.id}>
                <video
                  controls
                  playsInline
                  preload="metadata"
                  ref={(element) => {
                    videoRefs.current[item.id] = element;
                  }}
                  src={item.src}
                >
                  Su navegador no admite la reproducción de video.
                </video>
                <div className="product-media-card-content">
                  <h3>{item.title}</h3>
                </div>
              </article>
            ))}
          </div>

          <button
            aria-label="Siguiente contenido"
            className="product-media-navigation"
            onClick={() => moveCarousel(1)}
            type="button"
          >
            →
          </button>
        </div>

        <div className="product-media-pagination" aria-label="Seleccionar contenido">
          {MEDIA_ITEMS.map((item, index) => (
            <button
              aria-label={`Ir a ${item.title}`}
              aria-current={activeIndex === index ? "true" : undefined}
              className={activeIndex === index ? "product-media-dot is-active" : "product-media-dot"}
              key={item.id}
              onClick={() => scrollToIndex(index)}
              type="button"
            />
          ))}
        </div>
      </section>
    </Container>
  );
};

export default ProductMediaCarousel;
